import { render, staticRenderFns } from "./Big.vue?vue&type=template&id=61de42ee&scoped=true"
import script from "./Big.vue?vue&type=script&lang=js"
export * from "./Big.vue?vue&type=script&lang=js"
import style0 from "./Big.vue?vue&type=style&index=0&id=61de42ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61de42ee",
  null
  
)

export default component.exports